import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=e45844c8"
import script from "./ReadMore.vue?vue&type=script&lang=js"
export * from "./ReadMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports